import { X, Sparkles, ArrowUpRight } from 'lucide-react';

const MANUALE_AI_URL =
  'https://notebook.google.com/notebook/6edd59a4-2da5-4895-b8bc-2a2cc9c1c659?utm_source=gemini_notebook&utm_medium=referral&original_referer=https:%2F%2Fgemini.google.com%23&pli=1';

interface GuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function GuideModal({ isOpen, onClose }: GuideModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white dark:bg-zinc-900 rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-200 dark:border-zinc-800">
          <h2 className="text-lg font-semibold text-zinc-900 dark:text-white flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-violet-600 dark:text-violet-400" />
            Manuale AI
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
          >
            <X className="w-5 h-5 text-zinc-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5 space-y-4">
          <p className="text-sm text-zinc-700 dark:text-zinc-300 leading-relaxed">
            Il <strong>Manuale AI</strong> è l'assistente che conosce Nexus: funziona come una
            <strong> chat libera</strong> in cui puoi scrivere la tua domanda con parole tue.
          </p>
          <p className="text-sm text-zinc-700 dark:text-zinc-300 leading-relaxed">
            Può rispondere a quesiti su cosa fa ogni sezione, sui permessi necessari, sulle procedure
            passo-passo, sulle dashboard e sul significato degli errori.
          </p>

          <a
            href={MANUALE_AI_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-violet-700"
          >
            Apri il Manuale AI
            <ArrowUpRight className="h-4 w-4" />
          </a>

          <p className="text-xs text-zinc-500 dark:text-zinc-400 text-center">
            Il Manuale AI si apre in una nuova scheda. Non trovi risposta? Usa la voce
            <strong> Supporto</strong> nella sidebar.
          </p>
        </div>
      </div>
    </div>
  );
}
